// filter
// const pagination = () => ({
//     limit: 20,
//     offset: 0,
//     length: 0,
//     pageNumber: 0,
// });

const state = {
    listDataItem: [],

    // pagination: pagination(),
}

export {
    state as default,
    // pagination
}